import Base from "./Base";

class User extends Base {
    static getLoggedInUserColumns() {
        return this.sendRequest("/user/user/get-logged-in-user-columns", "GET");
    }

    static saveUserDetails(firstName, lastName) {
        return this.sendRequest("/user/user/save-user-details", "POST", {
            first_name: firstName,
            last_name: lastName
        });
    }
}

export default User;